import { PropsWithChildren } from "react";
import { defaultProps } from "helpers/common";
import { ExpandMore } from "@mui/icons-material";
import {
    Accordion,
    Typography,
    AccordionProps,
    TypographyProps,
    AccordionDetails,
    AccordionSummary,
    AccordionDetailsProps,
    AccordionSummaryProps,
} from "@mui/material";

export interface AppSectionAccordionProps extends PropsWithChildren {
    title: string;
    titleTextProps?: TypographyProps;
    accordionProps?: Partial<AccordionProps>;
    accordionSummaryProps?: Partial<AccordionSummaryProps>;
    accordionDetailsProps?: Partial<AccordionDetailsProps>;
}

function AppSectionAccordion(props: AppSectionAccordionProps) {
    const accordionProps = defaultProps(props?.accordionProps || {}, {
        sx: {
            boxShadow: "none",
            backgroundColor: "transparent",
            borderRadius: "0px !important",
            ".MuiButtonBase-root.MuiAccordionSummary-root": {
                width: "fit-content",
                minHeight: "fit-content",
            },
            ".MuiAccordionSummary-content": {
                margin: 0,
            },
            ".MuiSvgIcon-root": {
                fontSize: 16,
                color: "#32373E",
            },
            ".MuiAccordionSummary-content.Mui-expanded": {
                m: 0,
            },
            "&:before": {
                backgroundColor: "transparent",
            },
            margin: "0px !important",
        },
    });

    const accordionSummaryProps = defaultProps(props?.accordionSummaryProps || {}, {
        sx: {
            p: 0,
        },
        expandIcon: <ExpandMore />,
    });

    const titleTextProps: TypographyProps = defaultProps(props?.titleTextProps || {}, {
        sx: {
            fontSize: 16,
            fontWeight: 600,
            marginRight: 0.5,
        },
        children: props.title,
    });

    const accordionDetailsProps = defaultProps(props?.accordionDetailsProps || {}, {
        sx: {
            p: 0,
        },
        children: props.children,
    });

    return (
        <Accordion {...accordionProps}>
            <AccordionSummary {...accordionSummaryProps}>
                <Typography {...titleTextProps} />
            </AccordionSummary>
            <AccordionDetails {...accordionDetailsProps} />
        </Accordion>
    );
}

export default AppSectionAccordion;
